export default [
  {
    url: "/dispositivo",
    name: "devices",
    slug: "devices",
    i18n: "Devices",
    icon: "fa-mobile",
    iconPack: "far",
    featherIcon: false,
    visibleAny: true
  },
  {
    url: "/subscriptions",
    name: "subscriptions",
    slug: "subscriptions",
    i18n: "Subscriptions",
    icon: "fa-poll-h",
    iconPack: "far",
    featherIcon: false,
    visibleAny: true
  },
  // mobile
  {
    url: "/mobile/dashboard",
    name: "Dashboard",
    slug: "dashboardMobile",
    icon: "GridIcon",
    i18n: "Dashboard"
  },
  {
    header: "Redes Sociais",
    i18n: "RedesSociais",
    visibleMobile: true
  },
  {
    url: "/mobile/whatsapp-chat",
    name: "messenger",
    tag: 0,
    tagColor: "warning",
    slug: "chat",
    icon: "fa-whatsapp",
    iconPack: "fab",
    featherIcon: false,
    i18n: "whatsappChat",
    panelVersion: 0
  },
  {
    url: "/mobile/whatsapp-chat",
    name: "whatsapp",
    tag: 0,
    tagColor: "warning",
    slug: "chat",
    icon: "fa-whatsapp",
    iconPack: "fab",
    featherIcon: false,
    i18n: "whatsappChat",
    panelVersion: 1
  },
  {
    url: "/mobile/whatsapp-audio",
    name: "messengeraudio",
    tag: 0,
    tagColor: "warning",
    slug: "chat",
    icon: "fa-volume-up",
    iconPack: "far",
    featherIcon: false,
    i18n: "whatsappAudio",
    panelVersion: 0
  },
  {
    url: "/mobile/whatsapp-audio",
    name: "whatsappaudio",
    tag: 0,
    tagColor: "warning",
    slug: "chat",
    icon: "fa-volume-up",
    iconPack: "far",
    featherIcon: false,
    i18n: "whatsappAudio",
    panelVersion: 1
  },
  {
    url: "/mobile/whatsapp-call",
    name: "whatsappcall",
    tag: 0,
    tagColor: "warning",
    slug: "chat",
    icon: "fa-phone",
    iconPack: "far",
    featherIcon: false,
    i18n: "whatsappCall",
    panelVersion: 1
  },
  {
    url: "/mobile/instagram-chat",
    name: "instagram_chats",
    tag: 0,
    tagColor: "warning",
    slug: "chat",
    icon: "fa-instagram",
    iconPack: "fab",
    featherIcon: false,
    i18n: "Instagram"
  },
  {
    url: "/mobile/telegram-chat",
    name: "telegram",
    tag: 0,
    tagColor: "warning",
    slug: "chat",
    icon: "fa-telegram",
    iconPack: "fab",
    featherIcon: false,
    i18n: "telegram"
  },

  {
    header: "Monitoramento",
    i18n: "Monitoramento",
    visibleMobile: true
  },
  {
    url: "/mobile/apps",
    name: "app",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-grip-vertical",
    iconPack: 'far',
    featherIcon: false,
    i18n: "apps"
  },
  {
    url: "/mobile/chamadas",
    name: "call",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-phone",
    iconPack: "far",
    featherIcon: false,
    i18n: "Calls"
  },
  {
    url: "/mobile/teclas",
    name: "keylogger",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-keyboard",
    iconPack: "far",
    featherIcon: false,
    i18n: "Keys"
  },
  {
    url: "/mobile/contatos",
    name: "contact",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-address-card",
    iconPack: "far",
    featherIcon: false,
    i18n: "Contacts"
  },
  {
    url: "/mobile/sites",
    name: "webhistory",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-browser",
    iconPack: "far",
    featherIcon: false,
    i18n: "Websites"
  },
  {
    url: "/mobile/pesquisas",
    name: "websearch",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-search",
    iconPack: "far",
    featherIcon: false,
    i18n: "WebSearch"
  },
  {
    url: "/mobile/sms-chat",
    name: "sms",
    tag: 0,
    tagColor: "primary",
    slug: "chat",
    icon: "fa-sms",
    iconPack: "far",
    featherIcon: false,
    i18n: "SMS"
  },
  {
    url: "/mobile/localizacao",
    name: "location",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-map-marker-alt",
    iconPack: "far",
    featherIcon: false,
    i18n: "Location"
  },
  {
    url: "/mobile/zona-segura",
    name: "safezone",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-map-marker-check",
    iconPack: "far",
    featherIcon: false,
    i18n: "SafeZone"
  },
  {
    url: "/mobile/photogallery",
    name: "photogallery",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-camera",
    iconPack: 'far',
    featherIcon: false,
    i18n: "PhotoGallery"
  },
  // TODO Reativar link do menu quando função estiver terminada
  // {
  //   url: "/mobile/screenshot",
  //   name: "screenshot",
  //   tag: 0,
  //   tagColor: "primary",
  //   slug: "table",
  //   icon: "fa-camera",
  //   iconPack: 'far',
  //   featherIcon: false,
  //   i18n: "Screenshot"
  // },
  {
    url: "/mobile/foto-remota",
    name: "photo",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-camera-retro",
    iconPack: "far",
    featherIcon: false,
    i18n: "PhotoRemote",
    panelVersion: 0
  },
  {
    url: "/mobile/remotephoto",
    name: "remotephoto",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-camera-retro",
    iconPack: "far",
    featherIcon: false,
    i18n: "PhotoRemote",
    panelVersion: 1
  },
  {
    url: "/mobile/microfone",
    name: "microphone",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-microphone",
    iconPack: "far",
    featherIcon: false,
    i18n: "Microphone"
  },
  // desktop
  {
    header: "Desktop",
    i18n: "desktop",
    visibleDesktop: true
  },
  {
    url: "/desktop/teclas",
    name: "keylogger",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-keyboard",
    iconPack: "far",
    featherIcon: false,
    i18n: "keylogger"
  },
  {
    url: "/desktop/telas",
    name: "screenshot",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-image",
    iconPack: "far",
    featherIcon: false,
    i18n: "screenshots"
  },
  {
    url: "/desktop/sites",
    name: "httptraffic",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-globe",
    iconPack: "far",
    featherIcon: false,
    i18n: "Sites"
  },
  {
    url: "/desktop/pesquisas",
    name: "search",
    tag: 0,
    tagColor: "primary",
    slug: "table",
    icon: "fa-search",
    iconPack: "far",
    featherIcon: false,

    i18n: "Pesquisas"
  },

  {
    url: null,
    header: "helpAndSupport",
    i18n: "helpAndSupport",
    icon: "fa-search",
    visibleAny: true
  },

  {
    url: "/conta/perfil",
    name: "Profile",
    icon: "UserIcon",
    i18n: "Profile",
    visibleAny: true
  },
  {
    url: "/pages/videos",
    name: "Video",
    icon: "PlayIcon",
    i18n: "videos",
    visibleAny: true
  },
  {
    url: null,
    name: "FAQ",
    icon: "InfoIcon",
    i18n: "support",
    visibleAny: true,
    submenu: [
      {
        url: "/pages/suporte",
        name: "Suporte",
        icon: "InfoIcon",
        i18n: "support",
        visibleAny: true
      },
      {
        url: "/pages/termos-uso",
        name: "Termos",
        icon: "InfoIcon",
        i18n: "Terms",
        visibleAny: true
      },

    ]
  }
];
